import { SternumTheme } from '@sternum/theme';
import { DataGridTheme } from '@sternum/ui';

import { Colors } from '../constants';

export function SBOMLightDatagridTheme(theme: SternumTheme): Partial<DataGridTheme> {
  return {
    head: {
      backgroundColor: Colors.Lightest,
      border: 'none',
      borderRadius: '6px',
    },

    headCell: {
      padding: '5px 16px',
      separatorBorder: 'none',
      fontFamily: theme.fontFamily,
      fontSize: '12px',
      fontWeight: '600',
      color: Colors.GreyDarkest,
      textTransform: 'uppercase',
      lineHeight: '16px',
    },

    row: {
      backgroundColor: Colors.White,
    },

    bodyCell: {
      padding: '6px 16px',
      fontFamily: theme.fontFamily,
      fontSize: '12px',
      color: Colors.DarkerText,
      lineHeight: '18px',
    },
  };
}
